export const ID = 'AX7SMJAZAE'
export const KEY = '0991f2c6dd11847e90e1d46fda0c3c57'

export const KEYWRITE = '47be7bcda829ce15af557ebff4fcecae'